import { useFormikContext } from 'formik';
import React from 'react';
import { ShareConversations } from '../../form/fields/conversations';
import { ShareLinkFieldType, ShareLinkFormType } from '../../form/link-config-form.factory';

export const ShareConfigConversationPanel = () => {
  const { values, setFieldValue } = useFormikContext<ShareLinkFormType>();

  const onFieldChange = (payload: ShareLinkFieldType<unknown>) => {
    setFieldValue(payload.field, payload.value);
  };

  return (
    <ShareConversations
      conversation={{ field: 'allow_comments', value: values.allow_comments }}
      onFieldChange={onFieldChange}
    />
  );
};
